/**
 * FormAccessModal
 *
 * Shell for the form access dialog: owns `open` so antd drives the open/close
 * transition, and nothing else. `destroyOnHidden` unmounts `FormAccessContent`
 * while closed, so the assignment table's store subscriptions exist only while
 * the dialog is on screen.
 *
 * Allows admins to assign security groups to readGroupIds, writeGroupIds, or
 * adminGroupIds. Only `securityGroups/` is assignable here — business groups are
 * organizational roles and are never access-control principals, so `useFormAccess`
 * never surfaces them.
 */

import { FC } from 'react';
import { Modal } from 'antd';
import FormAccessContent from './FormAccessContent';

interface FormAccessModalProps {
    open: boolean;
    onClose: () => void;
}

export const FormAccessModal: FC<FormAccessModalProps> = ({
    open,
    onClose,
}) => (
    <Modal
        title="Manage Form Access"
        open={open}
        onCancel={onClose}
        footer={null}
        width={600}
        destroyOnHidden
    >
        <FormAccessContent />
    </Modal>
);

export default FormAccessModal;
